import {User} from '@app/modules/shared/models/user';
import {Project} from '@app/modules/shared/models/project';
import {ProjectInfluencerSegment} from '@app/modules/shared/models/project-influencer-segment';
import {Paging} from '@app/modules/shared/models/paging';

export class Campaign {
  id: number;
  code: string;
  project_id: number;
  project_influencer_segment_id: number;
  client_id: number;
  name: string;
  email_from_name: string;
  email_from: string;
  email_reply_to: string;
  email_source_message: string;
  email_body: string;
  email_subject: string;
  from_email_status: {};
  meta: any;
  launched_schedule_date: string;
  launched_at: string;
  first_launched_at: string;
  last_launched_at: string;
  launch_code: string;
  stage: string;
  created_by: number;
  status: string;
  landing_page_status: string;
  link_type: string;
  custom_cta_url: string;
  updated_at: string;
  created_at: string;
  client: User;
  project: Project;
  segments: ProjectInfluencerSegment[];
  influencer_segments: number[];
  influencer_dynamic_cta: string;
  sync_influencers_details: any;
  /** The launch syncs a registration platform install before it (`sync_influencers_details`). */
  sync_influencers_before_launch?: boolean;
  /** The launch syncs an install pushing share links once it has launched. */
  sync_influencers_after_launch?: boolean;
  sync_influencers_after_launch_details?: CampaignAfterLaunchSync | null;
}

/** The sync after a scheduled launch, as the campaigns list returns it. */
export interface CampaignAfterLaunchSync {
  project_registration_platform_id: number;
  registration_platform_id: number;
  /** The platform's slug. */
  sync_registration_platform: string;
  /** The install's name. */
  name: string;
  status: null | 'waiting' | 'pending' | 'finished' | 'failed';
  waiting_reason: string | null;
  task_log_id: number | null;
  initiated_at: string | null;
  completed_at: string | null;
  failure_message: string | null;
}

export class PaginatedCampaigns {
  list: Campaign[];
  paging: Paging;
}
